export default __webpack_public_path__ + "static/media/linkInvalid.f4dbc7ce.svg";